import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface GameSliceState {
  wss?: string;
  token?: string;
  connected: boolean;
  isLoading: boolean;
}

const initialState: GameSliceState = {
  connected: false,
  isLoading: false,
};

const gameSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload;
    },
    connectGame: (state, { payload }: PayloadAction<{ wss: string; token: string }>) => {
      state.token = payload.token;
      state.wss = payload.wss;
      state.connected = true;
      state.isLoading = false;
    },
    disconnectGame: (state) => {
      state.connected = false;
      state.token = undefined;
      state.wss = undefined;
    },
  },
});

export const { connectGame, disconnectGame, setLoading } = gameSlice.actions;

export default gameSlice.reducer;
